<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <div v-if="loading" class="text-center my-5">
                <b-spinner label="Carregando..."></b-spinner>
            </div>

            <b-form v-else @submit.prevent="save">
                <b-card>
                    <b-row style="margin-bottom: -14px">
                        <b-col md="3" lg="6" cols="12">
                            <lg-finder-page-tipo-aquisicao :disabled="isVisualizacao || !emConferencia()"
                                id="lgFinderTipoAquisicao" @onselect="handleTipoAquisicaoSelect"
                                v-model="form.tipoAquisicao" invalidFeedback="Tipo de Aquisição deve ser informada!"
                                description="" :prefix="prefix + title + ' > '"
                                :label="'Tipo Aquisição:*'"></lg-finder-page-tipo-aquisicao>
                        </b-col>

                        <b-col md="3" lg="6" cols="12">
                            <LgFinderPageEmpresa :disabled="isVisualizacao || !emConferencia() || idAutorizacao != null"
                                id="finderPageEmpresaRegistroForm" @input="handleFornecedor" v-model="form.fornecedor"
                                invalidFeedback="Empresa deve ser informada!" description="" :prefix="[prefix + title]"
                                :label="'Fornecedor:'">
                            </LgFinderPageEmpresa>
                        </b-col>

                        <lg-form-input :disabled="isVisualizacao" invalidFeedback="Este campo não pode ser vazio!"
                            description=" " v-model="form.notaFiscal" label="Nota Fiscal:" md="6" sm="6" cols="6" />

                        <b-col cols="6">
                            <LgFinderPagePessoa :disabled="isVisualizacao || !emConferencia()" id="findRequerente"
                                label="Requerente:*" @onselect="handleRequerente" v-model="form.requerente"
                                invalidFeedback="Informe um requerente!" :prefix="prefix + title + ' > '" />
                        </b-col>
                        <b-col md="5" lg="5" cols="5">
                            <LgFinderPageEmpenho :contrato="contrato" :status="statusEmpenho"
                                :disabled="isVisualizacao || !emConferencia() || idAutorizacao != null"
                                id="finderPageEmpenhoRegistroForm" @input="handleEmpenho" v-model="form.empenho"
                                invalidFeedback="Empenho deve ser informada!" description="" :prefix="[prefix + title]"
                                :value="form.empenho" label="Número Empenho:">
                            </LgFinderPageEmpenho>
                        </b-col>

                        <b-col cols="1" class="text-left mt-2">
                            <b-button :disabled="isVisualizacao || !emConferencia()" id="limparREForm" class="mr-2 my-2"
                                size="sm" style="height: 20px;margin-top: 15px" pill variant="primary"
                                @click="clearForm">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" /> &nbsp;
                                </div>
                                <b-tooltip target="limparREForm" title="Limpar"></b-tooltip>
                            </b-button>
                        </b-col>
                        <lg-form-input :disabled="isVisualizacao"
                            invalidFeedback="Informe um número de processo válido!" description=" "
                            v-model="form.nroProcesso" label="Nº Processo" md="6" sm="6" cols="6" />


                        <lg-form-input v-if="isVisualizacao" :disabled="true"
                            invalidFeedback="Informe um número de processo válido!" description=" "
                            v-model="form.dataEntrada" label="Data de Recebimento:*" md="4" sm="4" cols="4" />

                        <lg-form-date v-if="!isVisualizacao" :disabled="!emConferencia()"
                            invalidFeedback="A data de recebimento deve ser informada!" description=""
                            v-model="form.dataEntrada" label="Data de Recebimento:*" cols="4" sm="4" />

                        <lg-form-input @input="tratarHora" :disabled="isVisualizacao || !emConferencia()"
                            invalidFeedback="Informe uma hora!" description=" " v-model="form.horaEntrada"
                            label="Hora:*" md="2" sm="2" cols="2" />

                        <lg-form-input :disabled="isVisualizacao || contrato != null"
                            invalidFeedback="Informe um número de contrato válido!" description=" "
                            v-model="form.nroContrato" label="Nº Contrato:" md="6" sm="6" cols="6" />

                        <lg-form-input-number :disabled="isVisualizacao || !emConferencia()"
                            invalidFeedback="Este campo não pode ser vazio!" description=" "
                            v-model.number="form.vlNotaFiscal" label="Valor Nota Fiscal" md="6" sm="6" cols="6"
                            :precision="{ min: 2, max: 2 }" :isMoney="true" />

                        <lg-form-input :disabled="isVisualizacao" invalidFeedback="Informe uma observação válida!"
                            description=" " v-model="form.observacao" label="Observação:" md="6" sm="6" cols="12" />

                        <lg-form-input id="findRequerente" label="Resp.Criação:" v-model="form.respCriacao"
                            :disabled="true" md="3" sm="3" cols="3" />

                        <lg-form-input :disabled="true" invalidFeedback="Informe um número de processo válido!"
                            description=" " v-model="form.dhCriacao" label="Em:" md="3" sm="3" cols="3" />


                        <lg-form-input :disabled="true" invalidFeedback=" " description=" " v-model="form.id"
                            label="ID RE:" md="6" sm="6" cols="6" />

                    </b-row>
                    <b-form-row>
                        <b-col cols="12" class="text-right">
                            <b-button
                                v-if="!isVisualizacao && contrato == null && idAutorizacao == null && (!this.form.status || !this.form.status.id || emConferencia())"
                                class="ml-3 mb-4" size="sm" style="height: 20px" pill variant="success"
                                @click="addProdutoIntent" id="novo">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                            </b-button>
                        </b-col>
                    </b-form-row>
                    <b-table id="t-pessoas" small show-empty outlined responsive stacked="sm" head-variant="light"
                        :items="form.itens" :fields="itensFields">

                        <template #empty>
                            <h6 style="text-align: center">Nenhum item vinculado</h6>
                        </template>

                        <template v-slot:cell(limpar)="row">
                            <b-button :id="'limpar-item-re-' + row.index" :disabled="!emConferencia()"
                                @click="limparItem(row.item)" v-if="!isVisualizacao" class="pt-0 text-danger"
                                variant="link">
                                <b-icon icon="eraser" />
                            </b-button>
                            <b-tooltip :target="'limpar-item-re-' + row.index" title="Limpar linha..."></b-tooltip>
                        </template>


                        <template v-slot:cell(remover)="row">
                            <b-button :id="'remover-item-re-' + row.index" :disabled="!emConferencia()"
                                @click="removerItem(row.item)" v-if="!isVisualizacao" class="pt-0 text-danger"
                                variant="link">
                                <b-icon icon="trash2" />
                            </b-button>
                            <b-tooltip :target="'remover-item-re-' + row.index" title="Remover..."></b-tooltip>
                        </template>

                        <template v-slot:cell(valorRecebido)="row">
                            <lg-form-input-number
                                :disabled="!!idAutorizacao || contrato != null || isVisualizacao || !emConferencia()"
                                invalidFeedback="Este campo não pode ser vazio!" description=" "
                                v-model.number="row.item.valorRecebido" label=" " :precision="{ min: 2, max: 2 }"
                                :isMoney="true" />

                        </template>

                        <template v-slot:cell(quantidadeRecebida)="row">
                            <lg-form-input-number :disabled="isVisualizacao || !emConferencia()"
                                invalidFeedback="Este campo não pode ser vazio!" description=" "
                                v-model.number="row.item.quantidadeRecebida" label=" " />

                        </template>

                        <template v-slot:cell(valorServico)="row">

                            <lg-form-input-number
                                :disabled="isVisualizacao || !emConferencia() || (!(row.item.produto.tipoBem.id == 1 && row.item.produto.numero.startsWith('04')))"
                                invalidFeedback="Este campo não pode ser vazio!" description=" "
                                v-model.number="row.item.valorServico" label=" " :precision="{ min: 2, max: 2 }"
                                :isMoney="true" />

                        </template>

                        <template v-slot:cell(empenho)="row">
                            <LgFinderPageEmpenho :contrato="contrato"
                                :disabled="isVisualizacao || !emConferencia() || idAutorizacao != null"
                                :id="'finderPageEmpenhoRegistroFormItem' + row.index"
                                @input="function (empenho) { onSelectEmpenhoGrid(row.item, empenho) }"
                                v-model="row.item.empenho" invalidFeedback="Empenho deve ser informada!" description=""
                                :prefix="[prefix + title]" :value="form.empenho" label=" ">
                            </LgFinderPageEmpenho>
                        </template>
                        <template v-slot:cell(quantidadeMaximaRestante)='row'>
                            <b-form-group>
                                <span>{{ row.item.quantidadeMaximaRestante }}</span>
                            </b-form-group>
                        </template>
                    </b-table>
                    <div class="text-right">
                        <span>Total R$: {{ somaTotal }} </span>
                    </div>
                    <div class="text-right">
                        <span>
                            Diferença R$:
                            {{ diferenca }}
                        </span>
                    </div>
                    <b-form-row>
                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button v-if="!isVisualizacao" id="salvar" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>
                    </b-form-row>
                </b-card>
            </b-form>
        </b-modal>
        <ModalConsultaProdutoCadastroEssencial :podeMudarSituacao="false" :podeMudarTipo="false" v-if="showModalProduto"
            id="finderProdutoRegistroForm" @onselect="handleSelectProduto" invalidFeedback="Informe um produto!"
            :prefix="prefix + title + ' > '" />

    </b-form-row>
</template>

<script>
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageTipoAquisicao from "@/components/Finders/LgFinderPageTipoAquisicao.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormInputNumber from "@/core/components/Form/LgFormInputNumber.vue"
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import StatusEnum from "@/core/utils/StatusEnum"
import moment from "moment"
import ConfirmMixin from "@/core/mixins/confirm"


export default {
    components: {
        ModalConsultaProdutoCadastroEssencial,
        LgFinderPageEmpresa,
        LgFinderPageEmpenho: () => import("@/components/Finders/LgFinderPageEmpenho.vue"),
        LgFinderPageTipoAquisicao,
        LgFormInput,
        LgFormInputNumber,
        LgFinderPagePessoa,
        LgFormDate,
    },

    props: {
        isVisualizacao: {
            type: Boolean,
            default: false
        },
        idAutorizacao: {
            type: Number,
            default: null
        },
        contrato: {
            type: Object,
            default: null
        },

        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro",
        },
        id: {
            type: Number,
            default: null
        }
    },

    mixins: [FormResourceMixin, ConfirmMixin],

    data() {
        return {
            statusEmpenho: {},
            loading: true,
            showModalProduto: false,
            showModal: true,
            form: {
                horaEntrada: "",
                tipoAquisicao: {},
                requerente: {},
                notaFiscal: "",
                respCriacao: "",
                resultadoTotal: 0,
                diferenca: 0,
                vlNotaFiscal: 0,
                vlTotal: 0,
                vlServico: 0,
                valorServico: 0,
                quantidadeRecebida: 0,
                total: 0,
                nroEmpenho: "",
                nroContrato: "",
                empenho: {},
                fornecedor: {},
                status: {},
                dataEntrada: "",
                dhCriacao: "",
                itens: [],
                idAutorizacao: this.idAutorizacao,
                idContrato: this.contrato != null ? this.contrato.id : null,
                contrato: null
            },

            itemAtestoForm: {
                produto: {},
                empenho: {},
            },

            itensFields: (this.idAutorizacao || this.contrato != null) ? [
                { key: "produto.numero", label: "Número" },
                { key: "produto.descricaoResumida", label: "Produto" },
                { key: "produto.tipoMedida.descricao", label: "Unidade Medida" },
                { key: "empenho", label: "Empenho", tdClass: 'w-30' },
                { key: "valorRecebido", label: "Valor unitário", tdClass: 'w-20' },
                { key: "valorServico", label: "Valor serviço", tdClass: 'w-20' },
                { key: "quantidadeRecebida", label: "Quantidade recebida", tdClass: 'w-20' },
                { key: "quantidadeMaximaRestante", label: "Quantidade máxima faltante", tdClass: 'w-20' },
                { key: "limpar", label: " ", tdClass: "w-1" },
                { key: "remover", label: " ", tdClass: "w-1" },
            ] : [
                { key: "produto.numero", label: "Número" },
                { key: "produto.descricaoResumida", label: "Produto" },
                { key: "produto.tipoMedida.descricao", label: "Unidade Medida" },
                { key: "empenho", label: "Empenho", tdClass: 'w-30' },
                { key: "valorRecebido", label: "Valor unitário", tdClass: 'w-20' },
                { key: "valorServico", label: "Valor serviço", tdClass: 'w-20' },
                { key: "quantidadeRecebida", label: "Quantidade recebida", tdClass: 'w-20' },
                { key: "limpar", label: " ", tdClass: "w-1" },
                { key: "remover", label: " ", tdClass: "w-1" },
            ],
            showModalAddItemAtesto: false,
        }
    },
    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        brand.usuario.nome = `Responsável: ${brand.usuario.nome}`
        this.form.responsavel = brand.usuario
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/registros-entrada`)
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$serviceBemConsumo = new ResourceService(`/api/itens-bem-consumo`)
        this.$serviceSaldoAlmoxarifado = new ResourceService(
            `/api/saldo-almoxarifado-produto`
        )

        this.statusEmpenho = (await this.$serviceStatus.findById(StatusEnum.EMPENHO_EM_ANDAMENTO.value)).data


        if (this.id) {
            const { data } = await this.$service.findById(this.id)
            data.horaEntrada = moment(data.dataEntrada).format('HH:mm')
            data.dataEntrada = moment(String(data.dataEntrada)).format("YYYY-MM-DD")
            data.dhCriacao = moment(String(data.dhCriacao)).format("DD/MM/YYYY HH:mm")

            this.form = data;
            this.loading = false;


        }
        else
            if (this.contrato != null) {
                const [itensResponse] = await Promise.all([
                    new ResourceService("/api/item-contrato-reg-entrada").get(this.contrato.id),

                ]);
                this.form.itens = itensResponse.data
                this.form.nroContrato = this.contrato.numeroContrato;
                this.form.status.id = StatusEnum.EM_CONFERENCIA.value
                this.loading = false;
            }
            else
                if (this.idAutorizacao) {
                    const [itensResponse, participantesResponse] = await Promise.all([
                        new ResourceService("/api/itemautorizacaofornecimento").get(this.idAutorizacao),
                        new ResourceService("/api/autorizacaofornecedor/participantes").get(this.idAutorizacao)
                    ]);
                    this.form.itens = itensResponse.data
                    this.form.status.id = StatusEnum.EM_CONFERENCIA.value
                    this.form.empenho = participantesResponse.data[0].empenho;
                    this.form.fornecedor = participantesResponse.data[0].empresa;

                    this.form.itens.forEach(item => {
                        item.empenho = participantesResponse.data[0].empenho;
                    });

                    this.loading = false;

                    return
                }
                else {
                    this.loading = false;
                }


        this.form.horaEntrada = moment(new Date()).format('HH:mm')
        this.form.dataEntrada = moment(String(new Date())).format("YYYY-MM-DD")



    },

    computed: {
        somaTotal() {
            let valorTotal = 0
            if (this.form.itens && this.form.itens.length > 0) {
                for (const itemAtestoForm of this.form.itens) {
                    if (itemAtestoForm.produto.tipoBem.id === 1) {
                        valorTotal +=
                            ((itemAtestoForm.valorRecebido || 0) +
                                (itemAtestoForm.valorServico || 0)) *
                            (itemAtestoForm.quantidadeRecebida || 0)
                    } else {
                        valorTotal +=
                            (itemAtestoForm.valorRecebido || 0) *
                            (itemAtestoForm.quantidadeRecebida || 0)
                    }
                }
            }
            return valorTotal
        },
        diferenca() {
            return (this.form.vlNotaFiscal ? this.form.vlNotaFiscal : 0) - this.somaTotal
        },
    },


    methods: {
        tratarHora() {
            let numeros = this.form.horaEntrada.replace(/\D/g, '');

            if (numeros.length > 4) {
                numeros = numeros.slice(0, 4);
            }

            if (numeros.length === 4) {
                let hora = parseInt(numeros.slice(0, 2), 10);
                let minuto = parseInt(numeros.slice(2, 4), 10);

                if (hora > 23) hora = 23;
                if (minuto > 59) minuto = 59;

                this.form.horaEntrada =
                    `${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`;
            } else {
                this.form.horaEntrada = numeros;
            }
        },

        emConferencia() {
            if (this.id == null) {
                return true;
            }
            return this.form.status.id != null && this.form.status.id == StatusEnum.EM_CONFERENCIA.value
        },
        emAtesto(item) {
            return item.status.id != null && item.status.id == StatusEnum.ATESTO.value
        },

        limparItem(item) {
            item.empenho = {}
            item.valorRecebido = 0
            item.valorServico = 0
            item.quantidadeRecebida = 0
        },

        async handleSelectProduto(produto) {

            this.showModalProduto = false
            var existe = false
            await this.form.itens.forEach(item => {
                if (item.id == produto.id) {
                    existe = true
                }

            })

            if (existe) {

                this.$notify({
                    type: "warning",
                    message: "Esse Item já se encontra na lista",
                })
                return

            }
            else {

                console.log(produto);

                var produtoNovo = { valorRecebido: 0, valorServico: 0, quantidadeRecebida: 0, produto: produto };

                if (this.form.empenho && this.form.empenho.id) {
                    produtoNovo.empenho = this.form.empenho;
                }

                this.form.itens.push(produtoNovo);
            }
        },
        closeModalProduto() {
            this.showModalProduto = false
        },

        async addProdutoIntent() {
            this.showModalProduto = true
        },

        clearForm() {
            this.form.empenho = {}

            this.form.itens.forEach(item => {
                item.empenho = {}
            })

        },
        handleRequerente(pessoa) {
            this.form.requerente = pessoa
        },
        cancelar() {
            this.$emit("close")
        },

        async saveFunction() {
            try {

                this.form.vlTotal = this.somaTotal
                this.form.dataEntradaFormatada = moment(String(this.form.dataEntrada)).format("DD/MM/YYYY")

                await this.$saveResource(this.form, "", false)
                this.cancelar()
            } catch (error) {

                this.$notify({
                    type: "warning",
                    message: error,
                })
            }

        },
        async save() {
            if ((!this.form.tipoAquisicao || !this.form.tipoAquisicao.id)) {
                this.$notify({
                    type: "warning",
                    message: "Tipo Aquisição é obrigatório",
                })
                return
            }

            if ((!this.form.requerente || !this.form.requerente.id)) {
                this.$notify({
                    type: "warning",
                    message: "Requerente é obrigatório",
                })
                return
            }

            if ((!this.form.dataEntrada || this.form.dataEntrada == "")) {
                this.$notify({
                    type: "warning",
                    message: "Data de Recebimento é obrigatória",
                })
                return
            }

            if ((!this.form.horaEntrada || this.form.horaEntrada == "")) {
                this.$notify({
                    type: "warning",
                    message: "Hora de Entrada é obrigatória",
                })
                return
            }

            if (this.form.itens.length == 0) {
                this.$notify({
                    type: "danger",
                    message: "É preciso informar um item.",
                })
                return
            }

            var mensagemErro = ""
            var erroEmpenho = false
            var erroServico = false
            var erroRecebido = false
            var erroValor = false
            this.form.itens.forEach(item => {
                if (this.idAutorizacao || this.contrato != null) {
                    if ((item.quantidadeRecebida) > item.quantidadeMaximaRestante) {
                        mensagemErro += `O valor total do item ${item.produto.descricaoResumida} é maior que o valor máximo solicitado.`
                    }
                }

                if ((!item.empenho || !item.empenho.id) && !erroEmpenho) {
                    mensagemErro += "É necessario informar o Empenho do item."
                    erroEmpenho = true
                }

                if ((item.valorServico < 0) && !erroServico) {
                    mensagemErro += "O valor do serviço é menor que 0."
                    erroServico = true
                }

                if ((!item.valorRecebido || item.valorRecebido <= 0) && !erroValor) {
                    erroValor = true
                    mensagemErro += "O valor Unitário é menor ou igual a 0."
                }

                if ((!item.quantidadeRecebida || item.quantidadeRecebida <= 0) && !erroRecebido) {
                    erroRecebido = true
                    mensagemErro += "A quantidade recebida é menor ou igual a 0."
                }
            })

            if (mensagemErro != "") {
                let response = await this.$confirm(
                    "Confirmação",
                    "Foram identificadas as seguintes situações nesse Registro de Entrada: " + mensagemErro + "\nConfirmar os lançamentos do RE?",
                );

                if (response) {
                    this.saveFunction();
                }

                return;

            }

            this.saveFunction();
        },

        async removerItem(item) {

            let response = await this.$confirm(
                "Confirmação",
                "Tem certeza que deseja excluir este registro?",
            );

            if (response) {
                this.form.itens.splice(this.form.itens.indexOf(item), 1)
            }

        },

        async exibirSituacaoAtesto() {
            return this.form.status == undefined || this.form.status.id != 148
        },

        async onSelectEmpenho(empenho) {
            this.form.empenho = { id: empenho.id, numero: empenho.numero }
            this.form.nroEmpenho = empenho.numero

            this.form.itens.forEach(function (item) {
                item.empenho = { id: empenho.id, numero: empenho.numero }
            })
        },

        async onSelectEmpenhoGrid(item, empenho) {

            if (!empenho)
                return;
            item.empenho = { id: empenho.id, numero: empenho.numero, descricao: empenho.descricao }

        },

        async handleTipoAquisicaoSelect(tipoAquisicao) {
            this.form.tipoAquisicao = tipoAquisicao;
        },
        handleFornecedor(fornecedor) {
            this.form.fornecedor = fornecedor
        },

        async handleEmpenho(empenho) {


            this.form.empenho = { id: empenho.id, numero: empenho.numero, descricao: empenho.descricao }

            this.form.itens.forEach(function (item) {
                item.empenho = { id: empenho.id, numero: empenho.numero, descricao: empenho.descricao }
            });

            this.form.fornecedor = { id: empenho.idEmpresa, razaoSocial: empenho.empresa }
        },

        async onSelectEmpresa(item) {
            this.form.fornecedor = item
        },


        async buscarPessoa() {
            this.$service = new ResourceService(`/api/pessoa`)
            return await this.$servicePessoa.findAll({})
        },

        async showPessoa() {
            await this.$refs.finderPessoa.show()
        },

        async editarResource(item) {
            if (!this.$router) {
                throw new Error("this.$router cannot be null")
            }

            this.$router.push({
                name: "editarRegistroEntradaAtesto",
                params: { id: this.$route.params.id, atestoId: item.id },
                query: {
                    bemConsumoId: item.itemBemConsumo ? item.itemBemConsumo.id : null,
                },
            })
        },
    },
}
</script>
<style>
.input-color {
    background-color: yellow;
}
</style>
